module.exports = __webpack_public_path__ + "static/media/01-01__.d4304aad.mp3";